// extracted by mini-css-extract-plugin
module.exports =  {"yui3-css-stamp":"yui3-css-stamp__-qvAy","cssreset":"cssreset__HrQQR","clearfix":"clearfix__tDuI8"};